import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SuporteTicketsService } from '../../services/suporte-tickets.service';
import { WhatsappService } from '../../services/whatsapp.service';
import { AutorizacaoService } from '../../services/autorizacao.service';

@Component({
  selector: 'app-tickets-suporte',
  templateUrl: './tickets-suporte.component.html',
  styleUrls: ['./tickets-suporte.component.scss']
})
export class TicketsSuporteComponent implements OnInit, OnChanges {
  @Input() empresa: any;
  @Input() grupo: any;
  @Input() contato: any;
  @Input() compacto = false;

  tickets: any[] = [];
  ticketsResolvidosRecentes: any[] = [];
  ticketSelecionado: any;
  responsaveis: any[] = [];
  erro = '';
  erroResolvidosRecentes = '';
  avisoAvaliacao = '';
  carregando = false;
  carregandoResolvidosRecentes = false;
  salvando = false;
  criando = false;
  novoTicketAberto = false;
  comentarioTexto = '';
  contextoTexto = '';
  arquivoSelecionado: File;
  resolucaoModalAberto = false;
  resolucaoTexto = '';
  erroResolucao = '';
  cancelamentoModalAberto = false;
  cancelamentoTexto = '';
  erroCancelamento = '';
  desenvolvimentoModalAberto = false;
  desenvolvimentoTicket: any = {};
  erroDesenvolvimento = '';
  enviandoDesenvolvimento = false;
  usuario: any;
  permissoesSuporte: any = {};
  atividadeImplantacaoAtual: any;
  carregandoAtividadeImplantacao = false;
  salvandoAtividadeImplantacao = false;
  erroAtividadeImplantacao = '';
  configuracaoSuporte: any = {
    envioAutomaticoAvaliacaoAtivo: true
  };
  private readonly imagemAvaliacaoSuporte = '/images/suporte-avaliacao/mia-avaliacao-atendimento.png';

  novoTicket: any = this.novoTicketLimpo();

  statusOptions = [
    { valor: 'ABERTO', texto: 'Aberto' },
    { valor: 'EM_ANDAMENTO', texto: 'Em andamento' },
    { valor: 'AGUARDANDO_CLIENTE', texto: 'Aguardando cliente' },
    { valor: 'AGUARDANDO_DESENVOLVIMENTO', texto: 'Aguardando desenvolvimento' },
    { valor: 'RETORNO_DESENVOLVIMENTO', texto: 'Retorno do desenvolvimento' },
    { valor: 'RESOLVIDO', texto: 'Resolvido' },
    { valor: 'CANCELADO', texto: 'Cancelado' },
    { valor: 'BACKLOG', texto: 'Backlog' },
    { valor: 'TRIAGEM', texto: 'Triagem' },
    { valor: 'EM_DESENVOLVIMENTO', texto: 'Em desenvolvimento' },
    { valor: 'TESTE_QA', texto: 'Teste/QA' },
    { valor: 'EM_TESTES', texto: 'Teste/QA' },
    { valor: 'PRONTO_PARA_PRODUCAO', texto: 'Pronto para producao' },
    { valor: 'CONCLUIDO', texto: 'Concluido' },
    { valor: 'EM_PRODUCAO', texto: 'Em producao' }
  ];

  prioridades = [
    { valor: 'BAIXA', texto: 'Baixa' },
    { valor: 'NORMAL', texto: 'Normal' },
    { valor: 'ALTA', texto: 'Alta' }
  ];

  prioridadesDesenvolvimento = [
    { valor: 'URGENTE', texto: 'Urgente' },
    { valor: 'ALTA', texto: 'Alta' },
    { valor: 'MEDIA', texto: 'Media' },
    { valor: 'BAIXA', texto: 'Baixa' }
  ];

  tiposTicketDesenvolvimento = [
    { valor: 'BUG', texto: 'Bug' },
    { valor: 'MELHORIA', texto: 'Melhoria' },
    { valor: 'AJUSTE', texto: 'Ajuste' },
    { valor: 'INVESTIGACAO', texto: 'Investigacao' },
    { valor: 'OUTRO', texto: 'Outro' }
  ];

  tiposTicket = [
    { valor: 'PROBLEMA', texto: 'Problema' },
    { valor: 'CONFIGURACAO_CADASTROS', texto: 'Configuração/Cadastros' },
    { valor: 'DUVIDA', texto: 'Dúvida' },
    { valor: 'SUGESTAO_MELHORIA', texto: 'Sugestão de melhoria' },
    { valor: 'CAMPANHA', texto: 'Campanha' },
    { valor: 'IMPRESSORA', texto: 'Impressora' },
    { valor: 'TREINAMENTO', texto: 'Treinamento' },
    { valor: 'IMPLANTACAO', texto: 'Implantação' },
    { valor: 'OUTRO', texto: 'Outro' }
  ];

  areasSistema = [
    { valor: '', texto: 'Não informado' },
    { valor: 'PEDIDOS', texto: 'Pedidos' },
    { valor: 'MESAS_COMANDAS', texto: 'Mesas/Comandas' },
    { valor: 'CARDAPIO_PRODUTOS', texto: 'Produtos/Cardápio' },
    { valor: 'LOJA_CONFIGURACOES', texto: 'Loja/Configurações' },
    { valor: 'ENTREGA_TAXAS', texto: 'Entrega/Taxas' },
    { valor: 'FORMAS_PAGAMENTO', texto: 'Pagamentos' },
    { valor: 'FISCAL_NOTAS', texto: 'Fiscal/Notas' },
    { valor: 'WHATSAPP', texto: 'WhatsApp' },
    { valor: 'MENSAGENS', texto: 'Mensagens' },
    { valor: 'MARKETING_CAMPANHAS', texto: 'Marketing/Campanhas' },
    { valor: 'CONTATOS_CRM', texto: 'Contatos/CRM' },
    { valor: 'FIDELIDADE', texto: 'Fidelidade' },
    { valor: 'MIA_CHATBOT', texto: 'MIA/Chatbot' },
    { valor: 'IMPRESSAO_KDS', texto: 'Impressão/KDS' },
    { valor: 'INTEGRACOES', texto: 'Integrações' },
    { valor: 'OUTRO', texto: 'Outro' }
  ];

  constructor(private suporteTicketsService: SuporteTicketsService,
              private whatsappService: WhatsappService,
              private autorizacaoService: AutorizacaoService) {
  }

  ngOnInit() {
    this.usuario = this.autorizacaoService.getUser() || {};
    this.carreguePermissoesSuporte();
    this.carregueConfiguracaoSuporte();
    this.carregueResponsaveis();
    this.carregueTickets();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes.empresa && !changes.empresa.firstChange) || (changes.contato && !changes.contato.firstChange)) {
      this.reinicieEstado();
      this.carregueTickets();
    }
  }

  get empresaId(): number {
    return Number(this.empresa && this.empresa.id);
  }

  get existemTickets(): boolean {
    return this.tickets && this.tickets.length > 0;
  }

  get existemResolvidosRecentes(): boolean {
    return this.ticketsResolvidosRecentes && this.ticketsResolvidosRecentes.length > 0;
  }

  abraNovoTicket() {
    if (!this.podeCriarTicket()) {
      this.erro = 'Seu usuario nao tem permissao para criar tickets de suporte.';
      return;
    }

    this.novoTicket = this.novoTicketLimpo();
    this.novoTicketAberto = true;
    this.erro = '';
  }

  canceleNovoTicket() {
    this.novoTicketAberto = false;
    this.novoTicket = this.novoTicketLimpo();
  }

  carregueTickets() {
    if (!this.empresaId) {
      return;
    }

    this.carregando = true;
    this.erro = '';
    this.carregueResolvidosRecentes();

    const promessaTickets = this.contato && this.contato.id ?
      this.suporteTicketsService.listeAbertosContato(this.contato.id) :
      this.suporteTicketsService.listeAbertosEmpresa(this.empresaId);

    promessaTickets.then(tickets => {
      this.tickets = tickets || [];

      if (this.ticketSelecionado) {
        const aindaAberto = this.tickets.find(ticket => Number(ticket.id) === Number(this.ticketSelecionado.id));

        if (!aindaAberto && this.statusFechado(this.ticketSelecionado.status)) {
          this.ticketSelecionado = null;
        }
      }
    }).catch(erro => {
      this.erro = erro || 'Não foi possível carregar tickets.';
    }).finally(() => {
      this.carregando = false;
    });
  }

  carregueResponsaveis() {
    this.suporteTicketsService.listeResponsaveis().then(responsaveis => {
      this.responsaveis = responsaveis || [];
    }).catch(() => {
      this.responsaveis = [];
    });
  }

  carreguePermissoesSuporte() {
    this.suporteTicketsService.minhasPermissoes().then(permissoes => {
      this.permissoesSuporte = permissoes || {};

      if (this.podeUsarBotaoImplantacao()) {
        this.carregueAtividadeImplantacao();
      } else {
        this.atividadeImplantacaoAtual = null;
      }
    }).catch(() => {
      this.permissoesSuporte = {};
      this.atividadeImplantacaoAtual = null;
    });
  }

  carregueAtividadeImplantacao() {
    this.carregandoAtividadeImplantacao = true;
    this.erroAtividadeImplantacao = '';

    this.suporteTicketsService.obtenhaMinhaAtividadeImplantacao().then(atividade => {
      this.atividadeImplantacaoAtual = atividade;
    }).catch(() => {
      this.atividadeImplantacaoAtual = null;
    }).finally(() => {
      this.carregandoAtividadeImplantacao = false;
    });
  }

  podeCriarTicket(): boolean {
    return this.permissoesSuporte && this.permissoesSuporte.podeCriarTicket === true;
  }

  podeTransferirTicket(): boolean {
    return this.permissoesSuporte && this.permissoesSuporte.podeAssumirTicket === true;
  }

  podeEnviarDesenvolvimento(): boolean {
    if (!this.ticketSelecionado || !this.permissoesSuporte || this.permissoesSuporte.podeEnviarTicketParaDesenvolvimento !== true) {
      return false;
    }

    if (this.statusFechado(this.ticketSelecionado.status)) {
      return false;
    }

    return !this.ticketSelecionado.desenvolvimentoTicket;
  }

  podeResolverTicket(): boolean {
    return !!this.ticketSelecionado && this.ticketSelecionado.status !== 'AGUARDANDO_DESENVOLVIMENTO';
  }

  podeUsarBotaoImplantacao(): boolean {
    return this.permissoesSuporte && this.permissoesSuporte.podeEntrarNoRodizio === true;
  }

  estaEmImplantacao(): boolean {
    return !!(this.atividadeImplantacaoAtual && this.atividadeImplantacaoAtual.id);
  }

  inicieImplantacao() {
    if (!this.podeUsarBotaoImplantacao()) {
      return;
    }

    this.salvandoAtividadeImplantacao = true;
    this.erroAtividadeImplantacao = '';

    this.suporteTicketsService.inicieMinhaAtividadeImplantacao(90).then(atividade => {
      this.atividadeImplantacaoAtual = atividade;
    }).catch(erro => {
      this.erroAtividadeImplantacao = erro || 'Nao foi possivel ativar o impedimento de implantacao.';
    }).finally(() => {
      this.salvandoAtividadeImplantacao = false;
    });
  }

  encerreImplantacao() {
    if (!this.estaEmImplantacao()) {
      return;
    }

    this.salvandoAtividadeImplantacao = true;
    this.erroAtividadeImplantacao = '';

    this.suporteTicketsService.encerreMinhaAtividadeImplantacao().then(() => {
      this.atividadeImplantacaoAtual = null;
    }).catch(erro => {
      this.erroAtividadeImplantacao = erro || 'Nao foi possivel encerrar o impedimento de implantacao.';
    }).finally(() => {
      this.salvandoAtividadeImplantacao = false;
    });
  }

  crieTicket() {
    if (!this.empresaId) {
      this.erro = 'Empresa não informada.';
      return;
    }

    if (!this.novoTicket.titulo || !String(this.novoTicket.titulo).trim()) {
      this.erro = 'Informe o título do ticket.';
      return;
    }

    this.criando = true;
    this.erro = '';

    this.suporteTicketsService.crie({
      empresaId: this.empresaId,
      suporteGrupoWhatsappId: this.grupo && this.grupo.id,
      suporteContatoWhatsappId: this.contato && this.contato.id,
      titulo: this.novoTicket.titulo,
      descricao: this.novoTicket.descricao,
      prioridade: this.novoTicket.prioridade,
      tipo: this.novoTicket.tipo,
      tipoOutroDescricao: this.novoTicket.tipoOutroDescricao,
      areaSistema: this.novoTicket.areaSistema,
      responsavelUsuarioId: this.novoTicket.responsavelUsuarioId,
      origem: this.contato && this.contato.id ? 'WHATSAPP_CONTATO' : (this.grupo && this.grupo.id ? 'WHATSAPP' : 'SUPERADMIN')
    }).then(ticket => {
      this.ticketSelecionado = ticket;
      this.novoTicketAberto = false;
      this.novoTicket = this.novoTicketLimpo();
      this.carregueTickets();
    }).catch(erro => {
      this.erro = erro || 'Não foi possível criar o ticket.';
    }).finally(() => {
      this.criando = false;
    });
  }

  selecioneTicket(ticket: any) {
    if (!ticket || !ticket.id) {
      return;
    }

    this.salvando = true;
    this.erro = '';
    this.avisoAvaliacao = '';

    this.suporteTicketsService.obtenhaTicket(ticket.id).then(ticketCompleto => {
      this.ticketSelecionado = ticketCompleto;
      this.comentarioTexto = '';
      this.contextoTexto = '';
      this.arquivoSelecionado = null;
      this.canceleResolucao();
      this.canceleCancelamento();
      this.canceleDesenvolvimento();
    }).catch(erro => {
      this.erro = erro || 'Não foi possível abrir o ticket.';
    }).finally(() => {
      this.salvando = false;
    });
  }

  mudeStatus(status: string, observacao?: string) {
    if (!this.ticketSelecionado || !status) {
      return;
    }

    if (this.ticketSelecionado.status === status) {
      return;
    }

    if (status === 'RESOLVIDO' && !this.normalizeTexto(observacao)) {
      if (!this.podeResolverTicket()) {
        this.erro = 'Aguarde o retorno do desenvolvimento antes de resolver o ticket.';
        return;
      }

      this.abraResolverTicket();
      return;
    }

    if (status === 'CANCELADO' && !this.normalizeTexto(observacao)) {
      this.abraCancelarTicket();
      return;
    }

    this.salvando = true;
    this.erro = '';
    this.erroResolucao = '';
    this.erroCancelamento = '';

    this.suporteTicketsService.mudeStatus(this.ticketSelecionado.id, status, observacao).then(ticket => {
      this.ticketSelecionado = ticket;
      if (status === 'RESOLVIDO') {
        this.canceleResolucao();
        this.envieAvaliacaoAposResolucao(ticket);
      }
      if (status === 'CANCELADO') {
        this.canceleCancelamento();
      }
      this.carregueTickets();
    }).catch(erro => {
      if (status === 'RESOLVIDO' && this.resolucaoModalAberto) {
        this.erroResolucao = erro || 'Não foi possível marcar como resolvido.';
      } else if (status === 'CANCELADO' && this.cancelamentoModalAberto) {
        this.erroCancelamento = erro || 'Não foi possível cancelar o ticket.';
      } else {
        this.erro = erro || 'Não foi possível alterar o status.';
      }
    }).finally(() => {
      this.salvando = false;
    });
  }

  abraResolverTicket() {
    if (!this.ticketSelecionado) {
      return;
    }

    if (!this.podeResolverTicket()) {
      this.erro = 'Aguarde o retorno do desenvolvimento antes de resolver o ticket.';
      return;
    }

    this.resolucaoTexto = '';
    this.erroResolucao = '';
    this.resolucaoModalAberto = true;
    this.canceleCancelamento();
  }

  canceleResolucao() {
    this.resolucaoModalAberto = false;
    this.resolucaoTexto = '';
    this.erroResolucao = '';
  }

  confirmeResolucao() {
    const resolucao = this.normalizeTexto(this.resolucaoTexto);

    if (!resolucao) {
      this.erroResolucao = 'Descreva como o ticket foi resolvido.';
      return;
    }

    this.mudeStatus('RESOLVIDO', resolucao);
  }

  abraCancelarTicket() {
    if (!this.ticketSelecionado) {
      return;
    }

    this.cancelamentoTexto = '';
    this.erroCancelamento = '';
    this.cancelamentoModalAberto = true;
    this.canceleResolucao();
  }

  canceleCancelamento() {
    this.cancelamentoModalAberto = false;
    this.cancelamentoTexto = '';
    this.erroCancelamento = '';
  }

  abraEnviarDesenvolvimento() {
    if (!this.podeEnviarDesenvolvimento()) {
      return;
    }

    this.desenvolvimentoTicket = {
      titulo: this.ticketSelecionado.titulo,
      descricao: this.ticketSelecionado.descricao || '',
      prioridade: this.prioridadeDesenvolvimentoPadrao(this.ticketSelecionado.prioridade),
      tipo: 'BUG',
      areaSistema: this.ticketSelecionado.areaSistema || '',
      solicitanteCliente: this.ticketSelecionado.empresaNome || '',
      arquivoUrl: '',
      previsaoConclusao: ''
    };
    this.erroDesenvolvimento = '';
    this.desenvolvimentoModalAberto = true;
    this.canceleResolucao();
    this.canceleCancelamento();
  }

  canceleDesenvolvimento() {
    this.desenvolvimentoModalAberto = false;
    this.desenvolvimentoTicket = {};
    this.erroDesenvolvimento = '';
  }

  confirmeEnviarDesenvolvimento() {
    if (!this.ticketSelecionado || !this.desenvolvimentoTicket.titulo || !String(this.desenvolvimentoTicket.titulo).trim()) {
      this.erroDesenvolvimento = 'Informe o titulo do ticket de desenvolvimento.';
      return;
    }

    if (!this.desenvolvimentoTicket.tipo) {
      this.erroDesenvolvimento = 'Informe o tipo do ticket de desenvolvimento.';
      return;
    }

    this.enviandoDesenvolvimento = true;
    this.erroDesenvolvimento = '';

    this.suporteTicketsService.envieParaDesenvolvimento(this.ticketSelecionado.id, this.desenvolvimentoTicket).then(ticket => {
      this.ticketSelecionado = ticket;
      this.canceleDesenvolvimento();
      this.carregueTickets();
    }).catch(erro => {
      this.erroDesenvolvimento = erro || 'Nao foi possivel enviar ao desenvolvimento.';
    }).finally(() => {
      this.enviandoDesenvolvimento = false;
    });
  }

  confirmeCancelamento() {
    const justificativa = this.normalizeTexto(this.cancelamentoTexto);

    if (!justificativa) {
      this.erroCancelamento = 'Informe a justificativa do cancelamento.';
      return;
    }

    this.mudeStatus('CANCELADO', justificativa);
  }

  statusAtual(status: string): boolean {
    return !!this.ticketSelecionado && this.ticketSelecionado.status === status;
  }

  altereResponsavel(responsavelUsuarioId: number) {
    if (!this.ticketSelecionado) {
      return;
    }

    this.salvando = true;
    this.erro = '';

    this.suporteTicketsService.altereResponsavel(this.ticketSelecionado.id, responsavelUsuarioId).then(ticket => {
      this.ticketSelecionado = ticket;
      this.atualizeTicketNaLista(ticket);
    }).catch(erro => {
      this.erro = erro || 'Não foi possível alterar o responsável.';
    }).finally(() => {
      this.salvando = false;
    });
  }

  carregueResolvidosRecentes() {
    if (!this.empresaId) {
      return;
    }

    this.carregandoResolvidosRecentes = true;
    this.erroResolvidosRecentes = '';

    const filtro: any = {
      empresaId: this.empresaId,
      status: 'RESOLVIDO',
      inicio: 0,
      quantidade: 3
    };

    if (this.contato && this.contato.id) {
      filtro.suporteContatoWhatsappId = this.contato.id;
    } else if (this.grupo && this.grupo.id) {
      filtro.suporteGrupoWhatsappId = this.grupo.id;
    }

    this.suporteTicketsService.liste(filtro).then(retorno => {
      this.ticketsResolvidosRecentes = retorno && retorno.tickets ? retorno.tickets : [];
    }).catch(erro => {
      this.erroResolvidosRecentes = erro || 'Não foi possível carregar tickets resolvidos recentes.';
    }).finally(() => {
      this.carregandoResolvidosRecentes = false;
    });
  }

  assumaTicket() {
    if (!this.ticketSelecionado) {
      return;
    }

    this.salvando = true;
    this.erro = '';

    this.suporteTicketsService.assuma(this.ticketSelecionado.id).then(ticket => {
      this.ticketSelecionado = ticket;
      this.atualizeTicketNaLista(ticket);
    }).catch(erro => {
      this.erro = erro || 'Não foi possível assumir o ticket.';
    }).finally(() => {
      this.salvando = false;
    });
  }

  podeAssumirTicket(): boolean {
    if (!this.ticketSelecionado || !this.usuario || !this.usuario.id) {
      return false;
    }

    if (!this.permissoesSuporte || this.permissoesSuporte.podeAssumirTicket !== true) {
      return false;
    }

    if (this.statusFechado(this.ticketSelecionado.status)) {
      return false;
    }

    return Number(this.ticketSelecionado.responsavelUsuarioId || 0) !== Number(this.usuario.id || 0);
  }

  salveClassificacao() {
    if (!this.ticketSelecionado) {
      return;
    }

    this.salvando = true;
    this.erro = '';

    this.suporteTicketsService.atualize({
      id: this.ticketSelecionado.id,
      titulo: this.ticketSelecionado.titulo,
      descricao: this.ticketSelecionado.descricao,
      prioridade: this.ticketSelecionado.prioridade,
      tipo: this.ticketSelecionado.tipo,
      tipoOutroDescricao: this.ticketSelecionado.tipoOutroDescricao,
      areaSistema: this.ticketSelecionado.areaSistema,
      responsavelUsuarioId: this.ticketSelecionado.responsavelUsuarioId
    }).then(ticket => {
      this.ticketSelecionado = ticket;
      this.atualizeTicketNaLista(ticket);
    }).catch(erro => {
      this.erro = erro || 'Não foi possível salvar a classificação.';
    }).finally(() => {
      this.salvando = false;
    });
  }

  adicioneComentario() {
    this.adicioneInteracao(this.comentarioTexto, 'COMENTARIO');
  }

  adicioneContexto() {
    this.adicioneInteracao(this.contextoTexto, 'CONTEXTO');
  }

  selecioneArquivo(event: any) {
    const files = event && event.target && event.target.files;
    this.arquivoSelecionado = files && files.length ? files[0] : null;
  }

  envieAnexo() {
    if (!this.ticketSelecionado || !this.arquivoSelecionado) {
      return;
    }

    this.salvando = true;
    this.erro = '';

    this.suporteTicketsService.adicioneAnexo(this.ticketSelecionado.id, this.arquivoSelecionado).then(ticket => {
      this.ticketSelecionado = ticket;
      this.arquivoSelecionado = null;
      this.atualizeTicketNaLista(ticket);
    }).catch(erro => {
      this.erro = erro || 'Não foi possível anexar o print.';
    }).finally(() => {
      this.salvando = false;
    });
  }

  textoStatus(status: string): string {
    const opcao = this.statusOptions.find(item => item.valor === status);
    return opcao ? opcao.texto : status;
  }

  textoPrioridade(prioridade: string): string {
    const opcao = this.prioridades.find(item => item.valor === prioridade);
    return opcao ? opcao.texto : prioridade;
  }

  private prioridadeDesenvolvimentoPadrao(prioridade: string): string {
    if (prioridade === 'ALTA' || prioridade === 'BAIXA' || prioridade === 'URGENTE') {
      return prioridade;
    }

    return 'MEDIA';
  }

  textoTipo(tipo: string, tipoOutroDescricao?: string): string {
    if (tipo === 'OUTRO' && tipoOutroDescricao) {
      return 'Outro: ' + tipoOutroDescricao;
    }

    const opcao = this.tiposTicket.find(item => item.valor === tipo);
    return opcao ? opcao.texto : (tipo || 'Problema');
  }

  textoArea(areaSistema: string): string {
    const opcao = this.areasSistema.find(item => item.valor === areaSistema);
    return opcao ? opcao.texto : 'Não informado';
  }

  textoTipoAtendimento(tipo: string): string {
    const mapa: any = {
      CRIACAO: 'Criação',
      ASSUMIDO: 'Assumiu',
      TRANSFERIDO: 'Transferido',
      IMPORTADO: 'Importado'
    };

    return mapa[tipo] || tipo;
  }

  iconeTipoAtendimento(tipo: string): string {
    const mapa: any = {
      ASSUMIDO: 'fa-user-check',
      TRANSFERIDO: 'fa-exchange-alt'
    };

    return mapa[tipo] || '';
  }

  textoDuracaoAtendimento(atendimento: any): string {
    const minutos = Number(atendimento && atendimento.duracaoMinutos);

    if (!Number.isFinite(minutos)) {
      return 'Tempo não informado';
    }

    if (minutos < 60) {
      return minutos + 'min';
    }

    const horas = Math.floor(minutos / 60);
    const minutosRestantes = minutos % 60;

    return horas + 'h' + (minutosRestantes ? ' ' + minutosRestantes + 'min' : '');
  }

  textoStatusAvaliacao(status: string): string {
    const mapa: any = {
      PENDENTE: 'Pendente',
      ENVIADA: 'Enviada',
      RESPONDIDA: 'Respondida'
    };

    return mapa[status] || status || 'Pendente';
  }

  textoNotaAvaliacao(avaliacao: any): string {
    if (!avaliacao || !avaliacao.nota) {
      return 'Sem nota';
    }

    return avaliacao.nota + '/5';
  }

  temNotaAvaliacaoTicket(ticket: any): boolean {
    return !!ticket && Number(ticket.avaliacaoSuporteNota || 0) > 0;
  }

  estrelasAvaliacaoTicket(ticket: any): string {
    const nota = Math.max(0, Math.min(5, Math.round(Number(ticket && ticket.avaliacaoSuporteNota || 0))));

    return '★★★★★'.substring(0, nota) + '☆☆☆☆☆'.substring(0, 5 - nota);
  }

  classeNotaAvaliacaoTicket(ticket: any): string {
    const nota = Number(ticket && ticket.avaliacaoSuporteNota || 0);

    if (!nota) {
      return 'avaliacao-sem-nota';
    }

    if (nota <= 3) {
      return 'avaliacao-baixa';
    }

    return 'avaliacao-boa';
  }

  envieAvaliacaoSuporteManual() {
    this.envieAvaliacaoSuporte(this.ticketSelecionado, false);
  }

  podeEnviarAvaliacaoSuporte(): boolean {
    const avaliacao = this.ticketSelecionado && this.ticketSelecionado.avaliacaoSuporte;

    return !!avaliacao && !!avaliacao.token && !!avaliacao.whatsappChatId && avaliacao.status !== 'RESPONDIDA';
  }

  classePrioridade(prioridade: string): string {
    const mapa: any = {
      BAIXA: 'ticket-prioridade-baixa',
      NORMAL: 'ticket-prioridade-normal',
      ALTA: 'ticket-prioridade-alta'
    };

    return mapa[prioridade] || '';
  }

  textoIdade(ticket: any): string {
    const horas = this.idadeTicketEmHoras(ticket);

    if (horas == null) {
      return 'Idade não informada';
    }

    if (horas < 1) {
      return 'Criado há menos de 1h';
    }

    if (horas < 24) {
      return 'Criado há ' + horas + 'h';
    }

    const dias = Math.floor(horas / 24);
    const horasRestantes = horas % 24;

    return 'Criado há ' + dias + 'd' + (horasRestantes ? ' ' + horasRestantes + 'h' : '');
  }

  classeIdade(ticket: any): string {
    const horas = this.idadeTicketEmHoras(ticket);

    if (horas == null) {
      return '';
    }

    if (horas >= 168) {
      return 'ticket-idade-critica';
    }

    if (horas >= 72) {
      return 'ticket-idade-alerta';
    }

    return '';
  }

  abraGrupoTicket(ticket: any) {
    const chatId = this.obtenhaGrupoWhatsappChatId(ticket);

    if (!chatId) {
      return;
    }

    this.whatsappService.abraConversa(chatId);
  }

  podeAbrirGrupoTicket(ticket: any): boolean {
    return !!this.obtenhaGrupoWhatsappChatId(ticket);
  }

  private obtenhaGrupoWhatsappChatId(ticket: any): string {
    return (ticket && ticket.grupoWhatsappChatId) || (this.grupo && this.grupo.whatsappChatId) || '';
  }

  private envieAvaliacaoAposResolucao(ticket: any) {
    if (!ticket || !ticket.id) {
      return;
    }

    this.envioAutomaticoAvaliacaoEstaAtivo().then(ativo => {
      if (!ativo) {
        this.avisoAvaliacao = 'A avaliação foi criada, mas o envio automático está desativado.';
        return;
      }

      if (ticket.avaliacaoSuporte) {
        this.envieAvaliacaoSuporte(ticket, true);
        return;
      }

      this.suporteTicketsService.obtenhaTicket(ticket.id).then(ticketCompleto => {
        this.ticketSelecionado = ticketCompleto;
        this.envieAvaliacaoSuporte(ticketCompleto, true);
      }).catch(() => {
        this.avisoAvaliacao = 'A avaliação foi criada, mas não foi possível carregar os dados para envio automático.';
      });
    });
  }

  private envieAvaliacaoSuporte(ticket: any, somentePendente: boolean) {
    const avaliacao = ticket && ticket.avaliacaoSuporte;

    this.avisoAvaliacao = '';

    if (!avaliacao || !avaliacao.token) {
      return;
    }

    if (somentePendente && avaliacao.status !== 'PENDENTE') {
      return;
    }

    if (!avaliacao.whatsappChatId) {
      this.avisoAvaliacao = 'Avaliação criada, mas não há WhatsApp de destino para envio automático.';
      return;
    }

    const mensagem = this.mensagemAvaliacaoSuporte(ticket, avaliacao);

    this.whatsappService.envieMensagemNoWhatsapp({
      id: 'suporte-avaliacao-' + avaliacao.id + '-' + new Date().getTime(),
      naoRegistrarServidor: true,
      telefone: this.normalizeDestinoWhatsappAvaliacao(avaliacao.whatsappChatId),
      mensagem,
      imagem: this.imagemAvaliacaoSuporte,
      tipoDeNotificacao: 'Suporte Avaliação'
    });

    this.suporteTicketsService.marqueAvaliacaoEnviada(avaliacao.id).then(avaliacaoAtualizada => {
      if (this.ticketSelecionado && this.ticketSelecionado.avaliacaoSuporte) {
        this.ticketSelecionado.avaliacaoSuporte = Object.assign({}, this.ticketSelecionado.avaliacaoSuporte, avaliacaoAtualizada);
      }
    }).catch(() => {
      this.avisoAvaliacao = 'A avaliação foi enviada no WhatsApp, mas não foi possível registrar o envio.';
    });
  }

  private mensagemAvaliacaoSuporte(ticket: any, avaliacao: any): string {
    const link = this.whatsappService.obtenhaUrlServidor() + '/avaliar-suporte/' + avaliacao.token;
    const mensagemPadrao = [
      '*Mia:*',
      'Oi! Aqui é a Mia, assistente do Promokit.',
      'O ticket #' + ticket.id + ' foi marcado como resolvido.',
      'Você pode avaliar rapidamente o atendimento neste link:',
      '[Link_Avaliacao_Suporte]',
      'Sua opinião ajuda a melhorar nosso suporte.'
    ].join('\n\n');
    const mensagem = avaliacao.mensagem || mensagemPadrao;

    return mensagem.replace('[Link_Avaliacao_Suporte]', link);
  }

  private normalizeDestinoWhatsappAvaliacao(whatsappChatId: string): string {
    const destino = (whatsappChatId || '').toString().trim();

    if (destino.indexOf('@c.us') !== -1) {
      return destino.replace('@c.us', '').replace(/\D/g, '');
    }

    return destino;
  }

  private carregueConfiguracaoSuporte() {
    this.suporteTicketsService.obtenhaConfiguracao().then(configuracao => {
      this.configuracaoSuporte = Object.assign({}, this.configuracaoSuporte, configuracao || {});
    }).catch(() => {});
  }

  private envioAutomaticoAvaliacaoEstaAtivo(): Promise<boolean> {
    return this.suporteTicketsService.obtenhaConfiguracao().then(configuracao => {
      this.configuracaoSuporte = Object.assign({}, this.configuracaoSuporte, configuracao || {});
      return this.configuracaoSuporte.envioAutomaticoAvaliacaoAtivo !== false;
    }).catch(() => {
      return this.configuracaoSuporte.envioAutomaticoAvaliacaoAtivo !== false;
    });
  }

  private idadeTicketEmHoras(ticket: any): number | null {
    if (!ticket || !ticket.dataCriacao) {
      return null;
    }

    const dataCriacao = new Date(ticket.dataCriacao).getTime();

    if (!dataCriacao) {
      return null;
    }

    return Math.max(0, Math.floor((Date.now() - dataCriacao) / (1000 * 60 * 60)));
  }

  private adicioneInteracao(texto: string, tipo: string) {
    if (!this.ticketSelecionado) {
      return;
    }

    if (!texto || !String(texto).trim()) {
      this.erro = tipo === 'CONTEXTO' ? 'Informe o contexto do ticket.' : 'Informe o comentário.';
      return;
    }

    this.salvando = true;
    this.erro = '';

    this.suporteTicketsService.adicioneInteracao(this.ticketSelecionado.id, texto, tipo).then(ticket => {
      this.ticketSelecionado = ticket;
      this.comentarioTexto = tipo === 'COMENTARIO' ? '' : this.comentarioTexto;
      this.contextoTexto = tipo === 'CONTEXTO' ? '' : this.contextoTexto;
      this.atualizeTicketNaLista(ticket);
    }).catch(erro => {
      this.erro = erro || 'Não foi possível registrar a informação.';
    }).finally(() => {
      this.salvando = false;
    });
  }

  private atualizeTicketNaLista(ticket: any) {
    const index = this.tickets.findIndex(item => Number(item.id) === Number(ticket.id));

    if (index >= 0) {
      if (this.statusFechado(ticket.status)) {
        this.tickets.splice(index, 1);
      } else {
        this.tickets[index] = ticket;
      }
    }
  }

  private statusFechado(status: string): boolean {
    return status === 'RESOLVIDO' || status === 'CANCELADO';
  }

  private reinicieEstado() {
    this.tickets = [];
    this.ticketsResolvidosRecentes = [];
    this.ticketSelecionado = null;
    this.erro = '';
    this.erroResolvidosRecentes = '';
    this.avisoAvaliacao = '';
    this.novoTicketAberto = false;
    this.novoTicket = this.novoTicketLimpo();
    this.comentarioTexto = '';
    this.contextoTexto = '';
    this.arquivoSelecionado = null;
    this.carregandoResolvidosRecentes = false;
    this.canceleResolucao();
    this.canceleCancelamento();
    this.canceleDesenvolvimento();
  }

  private novoTicketLimpo(): any {
    return {
      titulo: '',
      descricao: '',
      prioridade: 'NORMAL',
      tipo: 'PROBLEMA',
      tipoOutroDescricao: '',
      areaSistema: '',
      responsavelUsuarioId: null
    };
  }

  private normalizeTexto(valor: any): string {
    return valor == null ? '' : String(valor).trim();
  }
}
